import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  IconButton,
  Tooltip,
  Popover,
} from "@mui/material";
// Removed imports for @mui/x-date-pickers as they were causing resolution errors
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";

export default function FiltersDialog(props) {
  // State for activity type filter
  const [ticketsFilter, setTicketsFilter] = useState("myTickets");

  // State for status filter
  const [status, setStatus] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);

  // Options for Activity Type dropdown
  const ticketsFilterOptions = [
    {
      label: "Tickets Assigned to Me",
      value: "assignedToMe",
    },
    {
      label: "My Resolver Group Tickets",
      value: "resolverGroup",
    },
    {
      label: "My Tickets",
      value: "myTickets",
    },
  ];
  // Options for Status dropdown
  const statusOptions = [
    { id:1, label: "Open", value: "Open", color: "#007BFF" },
    { id:2, label: "In Progress", value: "In Progress", color: "#FD7E14" },
    { id:3, label: "Hold", value: "Hold", color: "#FFC107" },
    { id:4, label: "Resolved", value: "Resolved", color: "#20C997" },
    { id:5, label: "Closed", value: "Closed", color: "#6C757D" },
  ];

  const handleClickOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to reset activity type
  const handleResetActivityType = () => {
    setTicketsFilter("myTickets");
  };

  // Function to reset status
  const handleResetStatus = () => {
    setStatus("");
  };

  // Function to reset all filters
  const handleResetAll = () => {
    handleResetActivityType();
    handleResetStatus();
  };

  // Function to apply filters
  const handleApplyNow = (props) => {
    console.log("filter", props);    
    props.filterTickets(props.ticketFilterURLs[ticketsFilter], status);    
    setAnchorEl(null);
  };

  return (
    <ThemeProvider>
      <>
        <Tooltip title="Filter" style={{ cursor: "pointer", margin: "2px" }}>
          <IconButton
            sx={{ border: "0px", backgroundColor: "transparent" }}
            onClick={handleClickOpen}
          >
            <FilterListIcon color="primary" />
          </IconButton>
        </Tooltip>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Box sx={{ p: 2, minWidth: "350px" }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Filter Tickets
            </Typography>
            {/* Activity Type Filter */}
            <Box sx={{ marginBottom: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="subtitle1"
                  className="font-medium text-gray-700"
                >
                  Tickets
                </Typography>
                <Button
                  onClick={handleResetActivityType}
                  sx={{
                    textTransform: "none",
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "primary.light",
                      color: "white",
                    },
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  Reset
                </Button>
              </Box>
              <FormControl fullWidth variant="outlined" className="rounded-lg">
                <InputLabel id="tickets-filter-label">
                  Tickets Filter
                </InputLabel>
                <Select
                  labelId="tickets-filter-label"
                  id="tickets-filter-select"
                  value={ticketsFilter}
                  label="Tickets Filter"
                  onChange={(e) => setTicketsFilter(e.target.value)}
                >
                  {ticketsFilterOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Status Filter */}
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="subtitle1"
                  className="font-medium text-gray-700"
                >
                  Status
                </Typography>
                <Button
                  onClick={handleResetStatus}
                  sx={{
                    textTransform: "none",
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "primary.light",
                      color: "white",
                    },
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                >
                  Reset
                </Button>
              </Box>
              <FormControl fullWidth variant="outlined" className="rounded-lg">
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status-select"
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: option.color,
                            marginRight: 1,
                          }}
                        />
                        <span>{option.label}</span>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                mt: 3,
              }}
            >
              <Button
                onClick={handleResetAll}
                variant="outlined"
                className="normal-case text-gray-700 border-gray-300 hover:bg-gray-50 rounded-lg px-3 py-2"
                startIcon={<RestartAltIcon />}
              >
                Reset all
              </Button>
              <Button
                onClick={() => {
                  handleApplyNow(props);
                }}
                variant="contained"
                className="normal-case bg-teal-600 hover:border-white-300 text-white rounded-lg px-6 py-2 shadow-none"
                startIcon={<CheckCircleIcon />}
              >
                Apply now
              </Button>
            </Box>
          </Box>
        </Popover>
      </>
    </ThemeProvider>
  );
}
